import isEmpty from "lodash/isEmpty";
import { fork, put, takeLatest } from "redux-saga/effects";
import {
  fetchTransactions,
  fetchTransaction,
  setPaginatedList,
  setItem,
} from "../store/transactionsSlice";

import { callApi } from "./helpers/api";

import { startLoading, setSuccess, setError } from "../store/appSlice";

import * as PaymentsApi from "../api/Payments";
import { UUID } from "../utils";

function* fetchTransactionsSaga({
  payload,
}: {
  payload: {
    page: number;
    limit: number;
    order: "asc" | "desc";
    orderBy: any;
    statuses: string[] | null;
    startDate: string | null;
    endDate: string | null;
    minAmount: number | null;
    maxAmount: number | null;
    query: string | null;
  };
  type: string;
}) {
  const operationPath = "transactions.list";
  yield put(startLoading(operationPath));
  try {
    const {
      page = 0,
      limit,
      order,
      orderBy,
      statuses,
      query,
      startDate,
      endDate,
      minAmount,
      maxAmount,
    } = payload;
    const data = yield callApi(PaymentsApi.getPayments, {
      page,
      limit,
      order,
      orderBy,
      query,
      startDate,
      endDate,
      minAmount,
      maxAmount,
      statuses: !isEmpty(statuses) ? statuses : null,
    });

    yield put(setPaginatedList(data));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* fetchTransactionSaga({
  payload: { id },
}: {
  payload: { id: UUID };
  type: string;
}) {
  const operationPath = "transactions.item";
  yield put(startLoading(operationPath));
  try {
    const item = yield callApi(PaymentsApi.getPayment, { id });

    yield put(setItem({ id, item }));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* watchFetchTransactions() {
  yield takeLatest(fetchTransactions.type, fetchTransactionsSaga);
}

function* watchFetchTransaction() {
  yield takeLatest(fetchTransaction.type, fetchTransactionSaga);
}

export default function* rootSaga() {
  yield fork(watchFetchTransactions);
  yield fork(watchFetchTransaction);
}
